import { Button, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { FC } from 'react';

export interface InProgressTaskItem {
  key: string;
  storeId: string;
  storeName: string;
  category: string;
  targetDate: string | null;
  privateNote: string | null;
}

const inProgressTaskColumns: ColumnsType<InProgressTaskItem> = [
  {
    title: '매장명',
    dataIndex: 'storeName',
    key: 'storeName',
  },
  {
    title: '카테고리',
    dataIndex: 'category',
    key: 'category',
  },
  {
    title: '목표일',
    dataIndex: 'targetDate',
    key: 'targetDate',
  },
  {
    title: '내부 메모',
    dataIndex: 'privateNote',
    key: 'privateNote',
    ellipsis: true,
  },
];

interface InProgressTasksModalProps {
  open: boolean;
  onClose: () => void;
  items: InProgressTaskItem[];
}

const InProgressTasksModal: FC<InProgressTasksModalProps> = ({ open, onClose, items }) => {
  return (
    <Modal
      title='처리 중인 이슈 태스크 확인'
      open={open}
      onCancel={onClose}
      footer={[
        <Button key='close' onClick={onClose}>
          닫기
        </Button>,
      ]}
      width={700}>
      <p style={{ marginBottom: 16, color: '#666' }}>
        아래 이슈 태스크가 처리 중입니다. 청구서에 반영하려면 해당 태스크를 완료 처리하거나 목표일을 변경해 주세요.
      </p>
      <Table columns={inProgressTaskColumns} dataSource={items} pagination={false} scroll={{ y: 300 }} />
    </Modal>
  );
};

export default InProgressTasksModal;
